import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
};

const deactivationSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setDeactivationLoading: (state, action) => {
			state.loading = action.payload;
		},
		setDeactivationData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;
			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
			state.loading = false;
		},
		setModelsDeactivationLoading: (state, action) => {
			state.modelDeactivationLoading = action.payload;
		},
		setModelsDeactivationData: (state, action) => {
			const { models } = action.payload;
			state.models = models || [];
			state.modelDeactivationLoading = false;
		},
	},
});

export const {
	setDeactivationLoading,
	setDeactivationData,
	setModelsDeactivationLoading,
	setModelsDeactivationData,
} = deactivationSlice.actions;

export default deactivationSlice.reducer;
